import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AccessEnvironment from '../header/AccessEnvironment'
import { fetchGnbMenu } from 'features/gnb/gnbSlice'
import ServiceMenu from 'features/gnb/ServiceMenu'
import LoungeBoardNotice from 'features/loungeBoard/notice/LoungeBoardNotice'
import MyMenu from '../../features/gnb/MyMenu'
import LoungeBoardQna from '../../features/loungeBoard/notice/LoungeBoardQna'
import ServiceLink from '../../features/gnb/ServiceLink'
import { appendTiaraSearchParams } from '../../features/gnb/gnbUtils'

const AppHeader = () => {
  const dispatch = useDispatch()
  const { home } = useSelector(state => state.gnb)
  const { current } = useSelector(state => state.login)
  const { disabledLogoLink } = useSelector(state => state.layout)

  useEffect(() => {
    dispatch(fetchGnbMenu())
  }, [dispatch])

  return (
    <header id="kakaoHead" className="kakao_head type_head">
      <AccessEnvironment />
      <h1>
        {disabledLogoLink || home?.link?.href === undefined ? (
          <span id="kakaoLogo">
            <span className="ir_pm">Kakao business</span>
          </span>
        ) : (
          <a id="kakaoLogo" href={appendTiaraSearchParams(home.link.href)}>
            <span className="ir_pm">Kakao business</span>
          </a>
        )}
        <ServiceLink />
      </h1>
      <ServiceMenu />
      <div className="gnb_relate">
        <h2 className="screen_out">서비스 관련 메뉴</h2>
        <ul className="list_relate">
          <LoungeBoardNotice />
          <LoungeBoardQna />
          <li>
            <a
              href="https://cs.kakao.com/helps?service=186"
              target="_blank"
              rel="noopener noreferrer"
              className="link_gnb">
              고객센터
            </a>
          </li>
          {current && <MyMenu />}
        </ul>
      </div>
    </header>
  )
}

export default AppHeader
